/**
 * Booking form-wide constants shared across UI and persistence layers.
 *
 * Co-located drift test ([constants.test.ts](./constants.test.ts)) keeps
 * `BOOKING_FORM_VISIBLE_STEP_COUNT` in lockstep with `bookingFormConfig.steps`.
 */

export const BOOKING_FORM_VISIBLE_STEP_COUNT = 5;
